import {createReducer, on} from '@ngrx/store';
import {newContextAction} from '../../auth/auth-store/auth.actions';
import {pageChanged} from './paging.actions';
import {PagingState} from './paging.state';

export const initialPagingState: PagingState = {
  currentPages: {}
};

export const pagingReducer = createReducer(
  initialPagingState,

  on(pageChanged, (state, {key, newPageIndex}) => {
    const updatedPages = {...state.currentPages};
    updatedPages[key] = newPageIndex;
    return {currentPages: updatedPages};
  }),

  on(newContextAction, () => initialPagingState)
);
